import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbSeparator,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

export default function Path({ path }) {
  return (
    <Breadcrumb fontSize="12px">
      <BreadcrumbItem>
        <BreadcrumbLink href="#">Home</BreadcrumbLink>
      </BreadcrumbItem>

      {path.map((x, idx) => (
        <BreadcrumbItem key={idx}>
          <BreadcrumbLink as={RouterLink} to={x.to}>
            {x.name}
          </BreadcrumbLink>
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}
